import { Stack, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { useContext, useEffect } from "react";
import { SplashContext } from "../layout/layout";

const PrivacyPage = () => {
  const splashScreen = useContext(SplashContext);
  useEffect(() => {
    splashScreen();
    // eslint-disable-next-line
  }, []);
  return (
    <Container maxWidth="lg">
      <Stack
        spacing={1}
        sx={{ pt: 3, alignItems: "center", minHeight: "90vh" }}
      >
        <Typography variant="h5" color={"black"}>
          Privacy
        </Typography>
      </Stack>
    </Container>
  );
};
export default PrivacyPage;
